export default __webpack_public_path__ + "static/pathway-5-917fd426b4e1501dbd7cc5591ca16da0.jpg";